"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _PrivateWall = _interopRequireDefault(require("./PrivateWall.vue"));
var _default = exports.default = {
  name: 'MyProfile',
  components: {
    PrivateWall: _PrivateWall.default
  },
  data() {
    return {
      // Datos del usuario actual (Admin)
      currentUser: {
        name: 'Admin_User',
        handle: '@admin',
        avatar: 'https://i.pravatar.cc/150?u=admin',
        posts: '24',
        likes: '1.5k'
      },
      // En una app real esto vendría de un store global ($state)
      globalFeed: []
    };
  },
  created() {
    // Intentamos obtener el feed si está guardado en el estado global, 
    // o usamos uno por defecto para demostración.
    this.globalFeed = this.$state.im_verified_feed || [{
      userName: 'Admin_User',
      handle: '@admin',
      userAvatar: 'https://i.pravatar.cc/150?u=admin',
      text: 'Esta es mi primera publicación en mi perfil privado. 🚀',
      thumbnail: 'https://picsum.photos/seed/admin1/800/500',
      likes: 10,
      comments: 2,
      locked: false,
      date: '1 día'
    }];
  },
  methods: {
    goBack() {
      // Volver al muro general
      this.$state.$emit('active.component', 'ImVerified');
    },
    handlePublish(newPost) {
      const post = {
        userName: this.currentUser.name,
        handle: this.currentUser.handle,
        userAvatar: this.currentUser.avatar,
        text: newPost.text,
        thumbnail: 'https://picsum.photos/seed/' + Math.random() + '/800/500',
        likes: 0,
        comments: 0,
        locked: newPost.price > 0,
        label: newPost.price > 0 ? '$' + newPost.price : 'NUEVO',
        date: 'Ahora'
      };
      this.globalFeed.unshift(post);
      // Sincronizamos con el estado global si existe
      this.$state.im_verified_feed = this.globalFeed;
    }
  }
};